import React from 'react';
import { Link } from 'react-router-dom';
import CookieBanner from '../base/CookieBanner';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-[#51b038] mb-4">
              PINTOLOT
            </div>
            <p className="text-gray-300 mb-4">
              Servicios profesionales de pintura para particulares y empresas en Olot y la Garrotxa. 
              Calidad, experiencia y compromiso en cada proyecto.
            </p>
            <div className="flex space-x-4">
              <a href="tel:609936590" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl" />
              </a>
              <a href="mailto:info@pintolot.com.es" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl" />
              </a>
              <a href="https://wa.me/34609936590" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">
                <i className="fab fa-whatsapp text-xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">Inicio</Link></li>
              <li><Link to="/empresa" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">Empresa</Link></li>
              <li><Link to="/servicios" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">Servicios</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">FAQ</Link></li>
              <li><Link to="/contacto" className="text-gray-300 hover:text-[#51b038] transition-colors cursor-pointer">Contacto</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2" />
                Olot, Girona, España
              </p>
              <p className="flex items-center">
                <i className="ri-phone-line mr-2" />
                609 93 65 90
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2" />
                info@pintolot.com.es
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 PINTOLOT. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/politica-privacidad" className="text-gray-400 hover:text-[#51b038] text-sm transition-colors cursor-pointer">
              Política de Privacidad
            </Link>
            <Link to="/aviso-legal" className="text-gray-400 hover:text-[#51b038] text-sm transition-colors cursor-pointer">
              Aviso Legal
            </Link>
            <Link to="/politica-cookies" className="text-gray-400 hover:text-[#51b038] text-sm transition-colors cursor-pointer">
              Cookies
            </Link>
          </div>
        </div>
      </div>
      <CookieBanner />
    </footer>
  );
}
